import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "./common/App";
import { getCandidateDetails } from "../../service/employerapi";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";

const CandidateDetails = () => {
  const { candidateId } = useParams(); // must match :candidateId in route
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCandidate = async () => {
      try {
        setLoading(true);
        const res = await getCandidateDetails(candidateId);
        console.log("API response:", res);
        setCandidate(res.data); // or setCandidate(res) depending on API
      } catch (err) {
        console.error("Error fetching candidate details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (candidateId) {
      fetchCandidate();
    }
  }, [candidateId]);


  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!candidate) return <div className="text-center py-5">Candidate not found.</div>;

  return (
    <Layout>
      {/* ===== Hero Navigation ===== */}
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li><Link to="/employer-home">Home</Link></li>
                <li><Link to="/employer/candidate-list">Candidate List</Link></li>
                <li>Candidate Details</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Candidate Details ===== */}
      <div className="astroDetails candidateProfile pt-40 pb-40">
        <div className="site-width">
          <div className="row">
            {/* Left Sidebar */}
            <div className="col-md-4">
              <div className="astroSider">
                <div className="astrocard ondetails">
                  <div className="astrocContainer">
                    <div className="astrohead">
                      <div className="astroImg">
                        <img
                          src={candidate.image || "/assets/img/candidate-profiles/img1.jpg"}
                          alt="img"
                        />
                      </div>
                      <div className="astroName">
                        <h4>
                          {candidate.jobSeekerName}{" "}
                        </h4>
                        <ul className="astroAcheiver companyName">
                          <li>
                            <img src="/assets/img/icons/office.svg" width="20" alt="icon" />
                            <p>{candidate.jobProfile}</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="astroDetails">
                      <div className="astroinfo">
                        <li>
                          <img src="/assets/img/icons/location-.svg" alt="icon" />
                          <span>{candidate.city}, {candidate.state}</span>
                        </li>
                        <li>
                          <img src="/assets/img/icons/mail.png" alt="icon" />
                          <span>{candidate.email}</span>
                        </li>

                        <li>
                          <img src="/assets/img/icons/telephone.png" alt="icon" />
                          <span>+91 {candidate.phoneNumber}</span>
                        </li>
                        <li>
                          <img src="/assets/img/icons/date-of-birth.png" alt="icon" />
                          <span>{candidate.dateOfBirth}</span>
                        </li>
                        <li>
                          <img src="/assets/img/icons/gender-fluid.png" alt="icon" />
                          <span>{candidate.gender}</span>
                        </li>
                        <li>
                          <img src="/assets/img/icons/industry.png" alt="icon" />
                          <span>{candidate.industryType}</span>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-md-8">
              <div className="astroDetailsWrap">

                {/* Skills */}
                {candidate.skills && candidate.skills.length > 0 && (
                  <div className="wrapper mt-4">
                    <h4 className="titletwo">Skills</h4>
                    <div className="astrolBtns flex-wrap">
                      {candidate.skills.map((skill, idx) => (
                        <a href="#" key={idx} className="astrocatbadge">{skill}</a>
                      ))}
                    </div>
                  </div>
                )}

                {/* Education */}
                <div className="wrapper mt-4">
                  <h4 className="titletwo">Education & Qualification</h4>
                  <div className="row content">
                    {candidate.educations && candidate.educations.length > 0 ? (
                      candidate.educations.map((edu, idx) => (
                        <div className="col-12 col-md-6 mb-4" key={idx}>
                          <div className="card shadow-sm h-100">
                            <div className="card-body">
                              <h5 className="card-title">{edu.degree}</h5>
                              <h6 className="card-subtitle text-muted">{edu.boardOfUniversity}</h6>
                              <hr />
                              <p><strong>Session From:</strong> {moment(edu.sessionFrom, "DD-MM-YYYY").format("D MMMM, YYYY")}</p>
                              <p><strong>Session To:</strong> {moment(edu.sessionTo, "DD-MM-YYYY").format("D MMMM, YYYY")}</p>
                              <p><strong>Marks:</strong> {edu.marks}</p>
                              <p><strong>Grade/Percentage:</strong> {edu.gradeOrPercentage}%</p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="alert alert-info text-center">No education data found.</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Work Experience */}
                <div className="wrapper mt-2">
                  <h4 className="titletwo">Work Experience</h4>
                  <div className="row content">
                    {candidate.experiences && candidate.experiences.length > 0 ? (
                      candidate.experiences.map((exp, idx) => (
                        <div className="col-12 mb-4" key={idx}>
                          <div className="card shadow-sm h-100">
                            <div className="card-body">
                              <h5 className="card-title">{exp.companyName}</h5>
                              <h6 className="card-subtitle mb-2 text-muted">{exp.jobTitle}</h6>
                              <p><strong>Session:</strong> {moment(exp.sessionFrom, "DD-MM-YYYY").format("D MMMM, YYYY")} to {moment(exp.sessionTo, "DD-MM-YYYY").format("D MMMM, YYYY")}</p>
                              <p><strong>Role Description:</strong><br />{exp.roleDescription}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="alert alert-info text-center">No experience data found.</div>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CandidateDetails;
